// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["assets/admin/css/admin","assets/css/home"], () => (__webpack_require__("./resources/js/home.js")))
__webpack_require__.O(undefined, ["assets/admin/css/admin","assets/css/home"], () => (__webpack_require__("./resources/sass/home.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/admin/css/admin","assets/css/home"], () => (__webpack_require__("./resources/sass/admin/admin.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
